module.exports = __webpack_public_path__ + "img/complete_02.f67e06d4.png";